import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _Length___get_kilometers__impl__syiikt2f7wyh2ltp7k3 as _Length___get_kilometers__impl__syiikt,
  Companion_instance3nlomj2jjs1fp as Companion_instance,
} from './usefulTypes.mjs';
import { coerceIn1xblvmyr0tby6 as coerceIn } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  DoubleArraySerializertger6kqq08hw as DoubleArraySerializer,
  serializer1x79l67jvwntn as serializer,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  SerialDescriptorbzxbhtn690r4 as SerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      m2a() {
        return GeoCoordinateGeoJsonSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var GeoCoordinateClass;
function GeoCoordinate() {
  if (GeoCoordinateClass === VOID) {
    class $ {
      constructor(latitude, longitude) {
        this.w3l_1 = latitude;
        this.x3l_1 = longitude;
      }
      y3l(other) {
        return _Length___get_kilometers__impl__syiikt(this.z3l(other));
      }
      z3l(other) {
        var theta = this.x3l_1 - other.x3l_1;
        // Inline function 'kotlin.math.sin' call
        var x = deg2rad(this.w3l_1);
        var tmp = Math.sin(x);
        // Inline function 'kotlin.math.sin' call
        var x_0 = deg2rad(other.w3l_1);
        var tmp_0 = tmp * Math.sin(x_0);
        // Inline function 'kotlin.math.cos' call
        var x_1 = deg2rad(this.w3l_1);
        var tmp_1 = Math.cos(x_1);
        // Inline function 'kotlin.math.cos' call
        var x_2 = deg2rad(other.w3l_1);
        var tmp_2 = tmp_1 * Math.cos(x_2);
        // Inline function 'kotlin.math.cos' call
        var x_3 = deg2rad(theta);
        var dist = tmp_0 + tmp_2 * Math.cos(x_3);
        // Inline function 'kotlin.math.acos' call
        var x_4 = coerceIn(dist, -1.0, 1.0);
        dist = Math.acos(x_4);
        dist = rad2deg(dist);
        dist = dist * (60 * 1.1515);
        return Companion_instance.a3m(dist);
      }
      b3m(latitude, longitude) {
        return new (GeoCoordinate())(latitude, longitude);
      }
      c3m(latitude, longitude, $super) {
        latitude = latitude === VOID ? this.w3l_1 : latitude;
        longitude = longitude === VOID ? this.x3l_1 : longitude;
        return $super === VOID ? this.b3m(latitude, longitude) : $super.b3m.call(this, latitude, longitude);
      }
      toString() {
        return 'GeoCoordinate(latitude=' + this.w3l_1 + ', longitude=' + this.x3l_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.w3l_1);
        result = imul(result, 31) + getNumberHashCode(this.x3l_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GeoCoordinate()))
          return false;
        if (!equals(this.w3l_1, other.w3l_1))
          return false;
        if (!equals(this.x3l_1, other.x3l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GeoCoordinate', VOID, VOID, VOID, VOID, VOID, {0: GeoCoordinateGeoJsonSerializer_getInstance});
    GeoCoordinateClass = $;
  }
  return GeoCoordinateClass;
}
var GeoCoordinateArraySerializerClass;
function GeoCoordinateArraySerializer() {
  if (GeoCoordinateArraySerializerClass === VOID) {
    class $ {
      constructor() {
        GeoCoordinateArraySerializer_instance = this;
        this.d3m_1 = DoubleArraySerializer();
        this.e3m_1 = SerialDescriptor('com.lightningkite.GeoCoordinate/longLatArray', this.d3m_1.az());
      }
      az() {
        return this.e3m_1;
      }
      pz(decoder) {
        // Inline function 'kotlin.let' call
        var it = decoder.qz(this.d3m_1);
        var tmp0_longitude = it[0];
        var tmp1_latitude = it[1];
        return new (GeoCoordinate())(tmp1_latitude, tmp0_longitude);
      }
      f3m(encoder, value) {
        // Inline function 'kotlin.doubleArrayOf' call
        var tmp$ret$0 = new Float64Array([value.x3l_1, value.w3l_1]);
        encoder.nz(this.d3m_1, tmp$ret$0);
      }
      oz(encoder, value) {
        return this.f3m(encoder, value instanceof GeoCoordinate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GeoCoordinateArraySerializer', VOID, VOID, [KSerializer()]);
    GeoCoordinateArraySerializerClass = $;
  }
  return GeoCoordinateArraySerializerClass;
}
var GeoCoordinateArraySerializer_instance;
function GeoCoordinateArraySerializer_getInstance() {
  if (GeoCoordinateArraySerializer_instance === VOID)
    new (GeoCoordinateArraySerializer())();
  return GeoCoordinateArraySerializer_instance;
}
function GeoCoordinateGeoJsonSerializer$descriptor$lambda($this$buildClassSerialDescriptor) {
  $this$buildClassSerialDescriptor.zz('type', serializer(StringCompanionObject_instance).az());
  $this$buildClassSerialDescriptor.zz('coordinates', GeoCoordinateGeoJsonSerializer_getInstance().g3m_1.az());
  return Unit_instance;
}
var GeoCoordinateGeoJsonSerializerClass;
function GeoCoordinateGeoJsonSerializer() {
  if (GeoCoordinateGeoJsonSerializerClass === VOID) {
    class $ {
      constructor() {
        GeoCoordinateGeoJsonSerializer_instance = this;
        this.g3m_1 = DoubleArraySerializer();
        var tmp = this;
        tmp.h3m_1 = buildClassSerialDescriptor('com.lightningkite.GeoCoordinate/geojson', [], GeoCoordinateGeoJsonSerializer$descriptor$lambda);
      }
      az() {
        return this.h3m_1;
      }
      pz(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.h3m_1;
        var composite = decoder.l13(descriptor);
        var lat = 0.0;
        var lon = 0.0;
        $l$loop: while (true) {
          var index = composite.b14(GeoCoordinateGeoJsonSerializer_getInstance().h3m_1);
          switch (index) {
            case 0:
              composite.v13(GeoCoordinateGeoJsonSerializer_getInstance().h3m_1, 0);
              break;
            case 1:
              // Inline function 'kotlin.let' call

              var it = composite.y13(GeoCoordinateGeoJsonSerializer_getInstance().h3m_1, 1, GeoCoordinateGeoJsonSerializer_getInstance().g3m_1);
              lat = it[1];
              lon = it[0];
              break;
            case -1:
              break $l$loop;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unexpected index: ' + index;
              throw IllegalStateException().o4(toString(message));
          }
        }
        var result = new (GeoCoordinate())(lat, lon);
        composite.m13(descriptor);
        return result;
      }
      f3m(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.h3m_1;
        var composite = encoder.l13(descriptor);
        composite.a15(GeoCoordinateGeoJsonSerializer_getInstance().h3m_1, 0, 'Point');
        var tmp = GeoCoordinateGeoJsonSerializer_getInstance().h3m_1;
        var tmp_0 = GeoCoordinateGeoJsonSerializer_getInstance().g3m_1;
        // Inline function 'kotlin.doubleArrayOf' call
        var tmp$ret$0 = new Float64Array([value.x3l_1, value.w3l_1]);
        composite.c15(tmp, 1, tmp_0, tmp$ret$0);
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.f3m(encoder, value instanceof GeoCoordinate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'GeoCoordinateGeoJsonSerializer', VOID, VOID, [KSerializer()]);
    GeoCoordinateGeoJsonSerializerClass = $;
  }
  return GeoCoordinateGeoJsonSerializerClass;
}
var GeoCoordinateGeoJsonSerializer_instance;
function GeoCoordinateGeoJsonSerializer_getInstance() {
  if (GeoCoordinateGeoJsonSerializer_instance === VOID)
    new (GeoCoordinateGeoJsonSerializer())();
  return GeoCoordinateGeoJsonSerializer_instance;
}
function deg2rad(deg) {
  return deg * 3.141592653589793 / 180.0;
}
function rad2deg(rad) {
  return rad * 180.0 / 3.141592653589793;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  GeoCoordinate as GeoCoordinatemhej4memzolm,
  Companion_instance_0 as Companion_instance2o2rsvptme3gi,
  GeoCoordinateArraySerializer_getInstance as GeoCoordinateArraySerializer_getInstance1v36ss1z42d62,
  GeoCoordinateGeoJsonSerializer_getInstance as GeoCoordinateGeoJsonSerializer_getInstance27i54kiunnp5w,
};
//endregion

//# sourceMappingURL=GeoCoordinate.mjs.map
